// extracted by mini-css-extract-plugin
export default {"GameScheduleCard":"GameScheduleCard_GameScheduleCard__6sh+f","RightContainer":"GameScheduleCard_RightContainer__9LO6k"};